import useProtoMethod from "./useProtoMethod";
import {
  ListAdvisorApplicationsRequest,
  ListAdvisorApplicationsResponse,
  GetAdvisorApplicationRequest,
  GetAdvisorApplicationResponse,
  UpdateAdvisorApplicationRequest,
  UpdateAdvisorApplicationResponse,
  SendAdvisorMeetingInvitationRequest,
  SendAdvisorMeetingInvitationResponse,
  SendAdvisorOfferEmailRequest,
  SendAdvisorOfferEmailResponse,
  SendAdvisorBackgroundCheckEmailRequest,
  SendAdvisorBackgroundCheckEmailResponse,
  SendAdvisorOnboardingEmailRequest,
  SendAdvisorOnboardingEmailResponse,
} from "../protogen/advisor_pipeline_service_pb";

const useListAdvisorApplications = (
  callback?: (r: ListAdvisorApplicationsResponse) => void,
) => {
  return useProtoMethod<
    ListAdvisorApplicationsRequest,
    ListAdvisorApplicationsResponse
  >("ListAdvisorApplications", ListAdvisorApplicationsResponse, { callback });
};

const useGetAdvisorApplication = (
  callback?: (r: GetAdvisorApplicationResponse) => void,
) => {
  return useProtoMethod<
    GetAdvisorApplicationRequest,
    GetAdvisorApplicationResponse
  >("GetAdvisorApplication", GetAdvisorApplicationResponse, { callback });
};

const useUpdateAdvisorApplication = (
  callback?: (r: UpdateAdvisorApplicationResponse) => void,
) => {
  return useProtoMethod<
    UpdateAdvisorApplicationRequest,
    UpdateAdvisorApplicationResponse
  >("UpdateAdvisorApplication", UpdateAdvisorApplicationResponse, { callback });
};

const useSendAdvisorMeetingInvitation = (
  callback?: (r: SendAdvisorMeetingInvitationResponse) => void,
) => {
  return useProtoMethod<
    SendAdvisorMeetingInvitationRequest,
    SendAdvisorMeetingInvitationResponse
  >("SendAdvisorMeetingInvitation", SendAdvisorMeetingInvitationResponse, {
    callback,
  });
};

const useSendAdvisorOfferEmail = (
  callback?: (r: SendAdvisorOfferEmailResponse) => void,
) => {
  return useProtoMethod<
    SendAdvisorOfferEmailRequest,
    SendAdvisorOfferEmailResponse
  >("SendAdvisorOfferEmail", SendAdvisorOfferEmailResponse, {
    callback,
  });
};

const useSendAdvisorBackgroundCheckEmail = (
  callback?: (r: SendAdvisorBackgroundCheckEmailResponse) => void,
) => {
  return useProtoMethod<
    SendAdvisorBackgroundCheckEmailRequest,
    SendAdvisorBackgroundCheckEmailResponse
  >(
    "SendAdvisorBackgroundCheckEmail",
    SendAdvisorBackgroundCheckEmailResponse,
    {
      callback,
    },
  );
};

const useSendAdvisorOnboardingEmail = (
  callback?: (r: SendAdvisorOnboardingEmailResponse) => void,
) => {
  return useProtoMethod<
    SendAdvisorOnboardingEmailRequest,
    SendAdvisorOnboardingEmailResponse
  >("SendAdvisorOnboardingEmail", SendAdvisorOnboardingEmailResponse, {
    callback,
  });
};

export {
  useListAdvisorApplications,
  useGetAdvisorApplication,
  useUpdateAdvisorApplication,
  useSendAdvisorMeetingInvitation,
  useSendAdvisorOfferEmail,
  useSendAdvisorBackgroundCheckEmail,
  useSendAdvisorOnboardingEmail,
};
